import React, { useEffect, useState } from "react";
import Paper from "@material-ui/core/Paper";
import InputBase from "@material-ui/core/InputBase";
import IconButton from "@material-ui/core/IconButton";
import SearchIcon from "@material-ui/icons/Search";
import MicIcon from "@material-ui/icons/Mic";
import SpeechRecognition, {
  useSpeechRecognition,
} from "react-speech-recognition";

export const VoiceSearchSeating = (props) => {
  const { transcript } = useSpeechRecognition();

  const [errors, setErrors] = useState({});
  const [utterancesVoice, setUtterancesVoice] = useState([]);
  const [utterancesVoiceText, setUtterancesVoiceText] = useState("");

  const addUtterancesVoiceActionMic = (valueText) => {
    //e.preventDefault();
    let utterancesVoiceTextVr = valueText;
    if (utterancesVoiceTextVr === "") {
      errors.utterancesVoiceTextVr = "Voice is Required";
      setErrors({
        errors: errors,
      });
    } else if (utterancesVoiceText === utterancesVoiceTextVr) {
      alert("Voice text already exits");
    } else {
      //   utterancesVoiceArr.push(utterancesVoiceTextVr);
      //   setUtterancesVoice(utterancesVoiceArr);
      setUtterancesVoiceText(utterancesVoiceTextVr);
      props.onVoiceSearchChange(utterancesVoiceTextVr);
    }
  };

  useEffect(() => {
    if (transcript) {
      addUtterancesVoiceActionMic(transcript);
    }
  }, [transcript]);

  return (
    <React.Fragment>
      <Paper component="div" className="enSearch2 d-flex">
        <IconButton type="button" aria-label="Search by Name or Phone Number">
          <SearchIcon />
        </IconButton>
        <InputBase
          placeholder="Search by Name or Phone Number"
          className="w-100"
          inputProps={{
            placeholder: "Search by Name or Phone Number",
          }}
          onChange={props.onSearchChange}
          value={props.search}
        />
        <IconButton
          type="button"
          aria-label="Search by Name or Phone Number"
          onClick={SpeechRecognition.startListening}
        >
          <MicIcon
          // onClick={(transcript) => addUtterancesVoiceActionMic(transcript)}
          />
        </IconButton>
      </Paper>
      <p className="text-danger f12-500">{errors.utterancesVoiceTextVr}</p>
    </React.Fragment>
  );
};

export default VoiceSearchSeating;


